module.exports = __webpack_public_path__ + "img/logo.b0f1af52.png";